import { Group } from '../../Components/Common/UI/Filter/Interfaces/Filter';

export const SET_AREA_FACET = 'SET_AREA_FACET';
export const SET_AREA_FACET_VALUE = 'SET_AREA_FACET_VALUE';
export const SET_AREA_GEOJSON = 'SET_AREA_GEOJSON';
export const SET_AREA_CRITERIA_ADVANCED_MODE = 'SET_AREA_CRITERIA_ADVANCED_MODE';
export const SET_AREA_CRITERIA = 'SET_AREA_CRITERIA';
export const SET_AREA_LAYER = 'SET_AREA_LAYER';

export const SET_FORM_PROPERTIES = 'SET_FORM_PROPERTIES';
export const CLEAR_AREA = 'CLEAR_AREA';